import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { TabService } from "../services/tab.service";
import { MessageService } from "../components/message/message.service";
import { filter, map } from "rxjs/operators";
import { isDefined } from "../utils/is-defined";
import { tabVerify } from "../utils/tab-verify";
import { tabCancel } from "../utils/tab-cancel";

@Injectable({
  providedIn: 'root'
})
export class DomainGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly tabService: TabService,
    private readonly messageService: MessageService
  ) {}

  canActivate() {
    return this.tabService.url$.pipe(
      filter(isDefined),
      map(url => {

        if (tabCancel(url)) {

          return this.denyActivate();

        } else {

          const verifier = tabVerify(url);

          if (verifier) {
            const tabAllowed = verifier?.isProduct();
            return tabAllowed || this.denyActivate();
          }

          return true;

        }

      })
    );
  }

  private denyActivate() {
    this.messageService.message$.next({
      icon: 'exclamation',
      body: `
        Перейдите на страницу товара, чтобы пожаловаться или заказать закупку
      `
    });
    return this.router.createUrlTree(['message']);
  }

}
